export const SET_AVAILABILITY_STATUS = 'SET_AVAILABILITY_STATUS';
export const SUBMITTING = 'SUBMITTING';